/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import { useRouter } from 'js/lib/useRouter';

import { Typography2 } from '@coursera/cds-core';

import { getDefaultResource } from 'bundles/directory-graphql/common/utils';
import ResourceNav from 'bundles/directory-graphql/components/ResourceNav';
import Results from 'bundles/directory-graphql/components/Results';
import PageHeader from 'bundles/page-header/components/PageHeader';

import _t from 'i18n!nls/directory-graphql';

const styles = {
  directoryLayout: css`
    margin-bottom: 20px;
    padding: 20px 60px 40px 60px;
    box-sizing: border-box;
    box-shadow: 0 1px 2px 1px rgb(0 0 0 / 25%);
    background-color: var(--cds-color-white-0);
    border-radius: 1px;
    height: 100%;
    overflow: hidden;
    max-width: 1056px;

    @media screen and (max-width: 767px) {
      padding-left: 8px;
      padding-right: 8px;
    }
  `,
  heading: css`
    border-bottom: 1px solid rgb(0 0 0 / 6%);
    width: 100%;
  `,
  header: css`
    margin-bottom: 30px;
    text-align: center;
    font-size: 32px;
    line-height: 36px;
    margin-top: 10px;
    font-weight: 400;
  `,
  results: css`
    padding-top: 16px;
    padding-bottom: 32px;
  `,

  container: css`
    margin-right: auto;
    margin-left: auto;
    padding-left: 15px;
    padding-right: 15px;

    @media screen and (min-width: 992px) {
      width: 970px;
    }

    @media screen and (min-width: 768px) {
      width: 750px;
    }

    @media screen and (min-width: 1200px) {
      width: 1170px;
    }
  `,
  row: css`
    display: flex;
    flex-wrap: wrap;
    margin-right: -15px;
    margin-left: -15px;
  `,
  titleColumn: css`
    position: relative;
    min-height: 1px;
    padding-left: 15px;
    padding-right: 15px;
    border-bottom: 1px solid rgb(0 0 0 / 6%);
    width: 100%;

    @media (min-width: 768px) {
      width: 100%;
      float: left;
    }
  `,
};

const DirectoryPage = () => {
  const router = useRouter();
  const selectedResource = router.params.resource || getDefaultResource();
  return (
    <div>
      <PageHeader />
      <div css={[styles.container, styles.directoryLayout]}>
        <div>
          <div css={styles.titleColumn}>
            <Typography2 component="h2" css={styles.header}>
              {_t('Directory')}
            </Typography2>
            <div className="c-divider" />
          </div>
        </div>
        <div css={styles.row}>
          <ResourceNav selectedResource={selectedResource} />
          <Results
            isDirectoryHomePage={!router.params.resource}
            label={selectedResource}
            selectedResource={selectedResource}
            queryParams={router.location.query}
          />
        </div>
      </div>
    </div>
  );
};

export default DirectoryPage;
